var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgRetrieveConfiguration = function SvgRetrieveConfiguration(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "black",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7 12.14L14.25 10.7C12.28 12.16 11 14.48 11 17.12C11 17.78 11.08 18.43 11.24 19.04C11.36 19.54 10.76 19.9 10.4 19.53C8.92 18 8 15.92 8 13.62C8 11.1 9.1 8.85 10.84 7.29L9.4 5.85C9.08 5.53 9.31 5 9.75 5H16.04C16.32 5 16.54 5.22 16.54 5.5V11.79C16.55 12.23 16.01 12.46 15.7 12.14Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgRetrieveConfiguration);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "retrieveConfiguration.4191c26e235ad41f5f6a6f85a6622fe5.svg";